import { ChangeEvent, ChangeEventHandler, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import NodeStore from '../../stores/NodeStore';
import InputOutputNode, { Data } from './base-nodes/InputOutputNode';
import { optionNode, captureResponseNode, emailNode, imageNode, promptNode, questionNode, yesNoNode } from '../../config/node-types';
const handleStyle = { left: 10 };

type Props = {
    data: {
        value: string,
        isAction: boolean
        showAfter: boolean,
    },
    isConnectable: boolean,
    id: string
}

const config = {
    name: 'Message Prompt',
    color: "#FF7276",
    nodeType: 'promptNode',
    inputs: [
        /*promptNode,        */
    ],
    outputs: [
        //{ ...questionNode, outputColor: '#66FF00' },
        //promptNode,                
        //{ ...emailNode, outputColor: '#43C6DB' },
        //{ ...imageNode, inputColor: '#66FF00' },
        //{ ...answerNode, outputColor: 'green' }
    ]
} as Data

function PromptNode({ data, isConnectable, id }: Props) {
    const onTextAreaChange = useCallback((evt: ChangeEvent<HTMLTextAreaElement>) => {
        NodeStore.update((s, o) => {
            const temp = structuredClone(o.chat);

            const node = temp.nodes.find(s => s.id === id);

            if (node) {
                node.data.value = evt.target.value;
            }
            localStorage.setItem('nodes', JSON.stringify(temp));
            s.isDirty = true;
            s.chat = temp;
        });
    }, []);    

    return (
        <InputOutputNode data={config} selected={false} nodeId={id} hidePrompts>
            <div className='main' style={{ display: 'flex', flexDirection: 'column' }}>
                <textarea placeholder='Enter a prompt' rows={6} cols={30} name="text" onChange={onTextAreaChange} className="nodrag" value={data.value} style={{ border: '1px solid lightgray;', borderRadius: 5, margin: 5, fontSize: 16, fontFamily: 'sans-serif', minWidth: 200 }} />                
            </div>
        </InputOutputNode>
    )
}

export default PromptNode;